import { render, staticRenderFns } from "./roamingService.vue?vue&type=template&id=01ead32c&scoped=true&"
import script from "./roamingService.vue?vue&type=script&lang=js&"
export * from "./roamingService.vue?vue&type=script&lang=js&"
import style0 from "./roamingService.vue?vue&type=style&index=0&id=01ead32c&prod&lang=scss&scoped=true&"
import style1 from "./roamingService.vue?vue&type=style&index=1&id=01ead32c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ead32c",
  null
  
)

export default component.exports